import React from "react";

const PublicFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className="projectFooter authFooter">
        <p>© {currentYear} Grouped.</p>
      </div>
    </>
  );
};

export default PublicFooter;
